import ReactPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';
import strings from '../localization/index.js';
import config from '../../constants/config';
import { Cookies } from 'react-cookie';
import { deepCopy } from './utils.js';

const cookies = new Cookies();

const defaultCookieObj = {
  necessary: {
    active: true,
    cookiesProviders: { romanceGuard: { active: true } },
  },
  functionallity: {
    active: true,
    cookiesProviders: {
      appsFlyer: {
        active: true,
      },
      raygun: {
        active: true,
      },
    },
  },
  analytics: {
    active: true,
    cookiesProviders: {
      google: {
        active: true,
      },
      vwo: {
        active: true,
      },
    },
  },
  marketing: {
    active: true,
    cookiesProviders: {
      bing: {
        active: true,
      },
      facebook: {
        active: true,
      },
      snapchat: {
        active: true,
      },
      taboola: {
        active: true,
      },
      tiktok: {
        active: true,
      },
      verizon: {
        active: true,
      },
    },
  },
};

const getGoogleTagObj = (accepted) => {
  return {
    ad_user_data: accepted ? 'granted' : 'denied',
    ad_personalization: accepted ? 'granted' : 'denied',
    ad_storage: accepted ? 'granted' : 'denied',
    analytics_storage: accepted ? 'granted' : 'denied',
  };
};

const initTikTokPixel = (debug = false) => {
  // https://github.com/ertemishakk/tiktok-pixel/
  if (config.TIKTOK_PIXEL) {
    TiktokPixel.init(config.TIKTOK_PIXEL, {}, { debug }) &&
      TiktokPixel.pageView();
  }
};

const injectMarketingScr = () => {
  require('./scripts/snapChat.js');
  require('./scripts/bing.js');
  require('./scripts/verizon.js');
  require('./scripts/taboola.js');
  initTikTokPixel();
};

const injectAnalyticsScr = () => {
  require('./scripts/vwo.js');
  // programski pozvati gtag
  window.gtag('consent', 'update', getGoogleTagObj(true));
};

const injectFunctionallityScr = () => {
  // banner za install mobilne app
  // console.log('STO NIJE INSTALIRAO BANNER????');
  require('./scripts/banner.js');
  require('./scripts/raygun.js');
  require('./scripts/vwo.js');
};

const injectIndividualScr = (providerId) => {
  switch (providerId) {
    case 'bing':
      require('./scripts/bing.js');
      break;
    case 'facebook':
      requiredConsentAccepted();
      break;
    case 'snapchat':
      require('./scripts/snapChat.js');
      break;
    case 'taboola':
      require('./scripts/taboola.js');
      break;
    case 'tiktok':
      initTikTokPixel();
      break;
    case 'verizon':
      require('./scripts/verizon.js');
      break;
    case 'vwo':
      require('./scripts/vwo.js');
      break;
    case 'google':
      window.gtag('consent', 'update', getGoogleTagObj(true));
      break;
    case 'appsFlyer':
      require('./scripts/banner.js');
      break;
    case 'raygun':
      require('./scripts/raygun.js');
      break;
    default:
      break;
  }
};

const injectOtherScr = () => {
  // neprikazati ako nema nista
};

const injectScriptsOnCookie = (cookie) => {
  if (cookie === 'functionallity') {
    injectFunctionallityScr();
  } else if (cookie === 'analytics') {
    injectAnalyticsScr();
  } else if (cookie === 'marketing') {
    injectMarketingScr();
  } else if (cookie === 'other') {
    injectOtherScr();
  }
};

export const injectAllScripts = () => {
  injectFunctionallityScr();
  injectAnalyticsScr();
  injectMarketingScr();
  injectOtherScr();
};

// runs on all no matter the consent
export const anyConsent = (debug = false) => {
  //
};

// only for non-mandatory consent countries & territories
export const nonRequiredConsent = (debug = false) => {
  // ovo kada nemora da se uopste trazi consent
  if (
    Array.isArray(config.FB_TRACKING_PIXEL_ID) &&
    config.FB_TRACKING_PIXEL_ID.length > 0
  ) {
    for (let index = 0; index < config.FB_TRACKING_PIXEL_ID.length; index++) {
      const fbPixel = config.FB_TRACKING_PIXEL_ID[index];
      ReactPixel.init(fbPixel, {}, { debug });
    }
    ReactPixel.pageView();
  }
};

// only for consent mandatory countries & territories // 1. ovo mora da se potegne
export const requiredConsentInit = (debug = false) => {
  if (
    Array.isArray(config.FB_TRACKING_PIXEL_ID) &&
    config.FB_TRACKING_PIXEL_ID.length > 0
  ) {
    for (let index = 0; index < config.FB_TRACKING_PIXEL_ID.length; index++) {
      const fbPixel = config.FB_TRACKING_PIXEL_ID[index];
      ReactPixel.init(fbPixel, {}, { debug });
    }
    ReactPixel.revokeConsent(); // it must be oustide for loop to work properly
    ReactPixel.pageView();
  }
};

export const requiredConsentAccepted = (debug = false) => {
  // 2. ovo ide posle kad mora consent
  if (config.FB_TRACKING_PIXEL_ID) {
    ReactPixel.grantConsent();
  }
};

export const requiredConsentDeclined = () => {
  if (config.FB_TRACKING_PIXEL_ID) {
    ReactPixel.revokeConsent();
  }
};

export const acceptCookies = (cookiesObj) => {
  const obj = deepCopy(defaultCookieObj);

  for (let key in cookiesObj) {
    const cookie = cookiesObj[key];
    if (cookie.active) {
      obj[key].active = true;

      for (let providerId in cookie.cookiesProviders) {
        const provider = cookie.cookiesProviders[providerId];
        if (provider.active) {
          obj[key].cookiesProviders[providerId].active = true;
          if (providerId === 'facebook') {
            requiredConsentAccepted();
          }

          if (providerId === 'google') {
            saveGoogleTagManagerCookie(true);
          }

          injectIndividualScr(providerId);
        } else {
          obj[key].cookiesProviders[providerId].active = false;
          if (providerId === 'facebook') {
            requiredConsentDeclined();
          }

          if (providerId === 'google') {
            saveGoogleTagManagerCookie(false);
          }

          deleteCookiesByProvider(providerId);
        }
      }
    } else {
      obj[key].active = false;
      for (let providerId in cookie.cookiesProviders) {
        const provider = cookie.cookiesProviders[providerId];
        obj[key].cookiesProviders[providerId].active = false;

        if (providerId === 'facebook') {
          requiredConsentDeclined();
        }

        if (providerId === 'google') {
          saveGoogleTagManagerCookie(false);
        }

        deleteCookiesByProvider(providerId);
      }
    }
  }

  obj.initial = false;

  saveCookieConsent(obj);
};

export const injectSelectedCookies = (cookiesObj) => {
  for (let key in cookiesObj) {
    const cookie = cookiesObj[key];
    if (cookie && cookie.active) {
      injectScriptsOnCookie(key);

      if (key === 'marketing' && cookie) {
        nonRequiredConsent();
      }
    } else if (!cookie.active) {
      for (let providerId in cookie.cookiesProviders) {
        const provider = cookie.cookiesProviders[providerId];

        if (provider.active) {
          injectIndividualScr(providerId);
        } else {
          deleteCookiesByProvider(providerId);
        }
      }
    }
  }
};

export const acceptAllCookies = () => {
  const obj = deepCopy(defaultCookieObj);
  obj.initial = false;
  saveGoogleTagManagerCookie(true);
  injectAllScripts();
  saveCookieConsent(obj);
};

export const declineAllCookies = () => {
  const obj = deepCopy(defaultCookieObj);
  obj.initial = false;

  for (let key in cookiesListObj) {
    if (key === 'necessary') {
      obj[key].active = true;
    } else {
      obj[key].active = false;
      const providers = obj[key].cookiesProviders;
      for (let providerId in providers) {
        obj[key].cookiesProviders[providerId].active = false;
      }
    }
  }

  obj.initial = false;

  requiredConsentDeclined();
  saveCookieConsent(obj);
  saveGoogleTagManagerCookie(false);
  deleteCookiesFromBrowser();
};

const deleteCookiesFromBrowser = () => {
  for (let key in providersCookiesList) {
    deleteCookiesByProvider(key);
  }
};

const deleteCookiesByProvider = (providerId) => {
  const provider = providersCookiesList[providerId];

  if (!provider) {
    return false;
  }

  if (providerId !== 'necessary' && provider.list && provider.list.length > 0) {
    for (let i = 0; i < provider.list.length; i++) {
      const cookieObj = provider.list[i];
      if (cookieObj.isFirstParty) {
        const regex = /(.*)\.(.*)\.(.*)$/;
        const str = config.DOMAIN.match(regex);
        if (config.DOMAIN.includes('localhost')) {
          // console.log('UDJE!');
          cookies.remove(cookieObj.id);
        } else {
          if (str[2] && str[3]) {
            const domain = `${str[2]}.${str[3]}`;
            const options = ['.', 'dev.', '.dev.', 'www.', '.www.'];
            for (let i = 0; i < options.length; i++) {
              const opt = options[i];
              const domainToMatch = `${opt}${domain}`;
              cookies.remove(cookieObj.id, { path: '', domain: domainToMatch });
            }
          } else {
            cookies.remove(cookieObj.id);
          }
        }
      }
    }
  }
};

export const getCookieConsent = () => {
  let obj = localStorage.getItem(config.COOKIE_CONSENT_NAME);

  if (obj && typeof obj === 'string') {
    return JSON.parse(obj);
  } else {
    const initialObj = deepCopy(defaultCookieObj);
    initialObj.initial = true;
    return initialObj;
  }
};

const saveCookieConsent = (cookieObj) => {
  localStorage.setItem(config.COOKIE_CONSENT_NAME, JSON.stringify(cookieObj));
};

const saveGoogleTagManagerCookie = (accepted = false) => {
  localStorage.setItem(
    config.COOKIE_GOOGLTE_TAG_MANAGER,
    JSON.stringify(getGoogleTagObj(accepted))
  );
};

export const cookiesListObj = {
  necessary: {
    active: true,
    title: strings.cookieNecessaryTitle,
    description: strings.cookieNecessaryDescription,
    cookiesProviders: { romanceGuard: { name: 'Romance Guard', active: true } },
  },
  functionallity: {
    active: true,
    title: strings.cookieFunctionallityTitle,
    description: strings.cookieFunctionallityDescription,
    cookiesProviders: {
      appsFlyer: {
        name: 'AppsFlyer',
        active: true,
      },
      raygun: {
        name: 'Raygun',
        active: true,
      },
    },
  },
  analytics: {
    active: true,
    title: strings.cookieAnalyticsTitle,
    description: strings.cookieAnalyticsDescription,
    cookiesProviders: {
      google: {
        name: 'Google Analytics',
        active: true,
      },
      vwo: {
        name: 'Visual Website Optimiser',
        active: true,
      },
    },
  },
  marketing: {
    active: true,
    title: strings.cookieMarketingTitle,
    description: strings.cookieMarketingDescription,
    cookiesProviders: {
      bing: {
        name: 'Bing',
        active: true,
      },
      facebook: {
        name: 'Facebook',
        active: true,
      },
      snapchat: {
        name: 'Snapchat',
        active: true,
      },
      taboola: {
        name: 'Taboola',
        active: true,
      },
      tiktok: {
        name: 'Tiktok',
        active: true,
      },
      verizon: {
        name: 'Verizon',
        active: true,
      },
    },
  },
  // other: {
  //   active: true,
  //   title: strings.cookieOtherTitle,
  //   description: strings.cookieOtherDescription,
  // cookiesArr: []
  // },
};
// facebook pixel: '_fbp'
// google analytics: '_ga', '_ga_1M1LTE26PK', '_gcl_au'
// snapchat: '_scid', '_scid_r', '_sctr'
// bing: '_uetsid', '_uetvid'
// visual website optimizer: '_vis_opt_s', '_vis_opt_test_cookie', '_vwo', '_vwo_ds', '_vwo_uuid', '_vwo_uuid_v2'
// romance guard: '__RG', '__RGt'

export const providersCookiesList = {
  bing: {
    name: 'Bing',
    active: true,
    privacyUrl: 'https://privacy.microsoft.com/en-us/privacystatement',
    list: [
      {
        id: 'MR',
        description: strings.cookiesBingRefreshMuid,
        expiration: `7 ${strings.days}`,
        domain: '.bat.bing.com',
      },
      {
        id: 'MSPTC',
        description: strings.cookiesBingAds,
        expiration: `1 ${strings.year}`,
        domain: '.bing.com',
      },
      {
        id: 'MUID',
        description: strings.cookiesBingTracking,
        expiration: `1 ${strings.year}`,
        domain: '.bing.com',
      },
      {
        id: 'MUID',
        description: strings.cookiesBingTracking,
        expiration: `1 ${strings.year}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_uetsid',
        description: strings.cookiesBingTrackingAdvertising,
        expiration: `1 ${strings.day}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_uetvid',
        description: strings.cookiesBingTrackingAdvertising,
        expiration: `1 ${strings.year}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_clck',
        description: strings.cookiesBingClarityID,
        expiration: `1 ${strings.day}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_clsk',
        description: strings.cookiesBingClarityMultiple,
        expiration: `1 ${strings.day}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
    ],
  },
  facebook: {
    name: 'Facebook',
    active: true,
    privacyUrl: 'https://www.facebook.com/privacy/policy/',
    list: [
      {
        id: '_fbp',
        description: strings.cookiesFacebookTracking,
        expiration: `3 ${strings.months}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: 'datr',
        description: strings.cookiesFacebookUniqueId,
        expiration: `13 ${strings.months}`,
        domain: '.facebook.com',
      },
      {
        id: 'dpr',
        description: strings.cookiesFacebookDevicePixelRatio,
        expiration: `7 ${strings.days}`,
        domain: '.facebook.com',
      },
      {
        id: 'fr',
        description: strings.cookiesFacebookMarketing,
        expiration: `3 ${strings.months}`,
        domain: '.facebook.com',
      },
      {
        id: 'wd',
        description: strings.cookiesFacebookDevicePixelRatio,
        expiration: `7 ${strings.days}`,
        domain: '.facebook.com',
      },
    ],
  },
  raygun: {
    name: 'Raygun',
    active: true,
    privacyUrl:
      'https://raygun.com/privacy#:~:text=Information%20is%20only%20used%20to,or%20revealing%20any%20personal%20information.',
    list: [
      {
        id: 'Raygun',
        description: strings.cookiesRaygun,
        expiration: null,
        domain: '.raygun.io',
      },
    ],
  },
  snapchat: {
    name: 'Snapchat',
    active: true,
    privacyUrl: 'https://values.snap.com/privacy/privacy-policy',
    list: [
      {
        id: '_scid',
        description: strings.cookiesSnapchatId,
        expiration: `1 ${strings.year}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_scid_r',
        description: strings.cookiesSnapchatTrackId,
        expiration: `1 ${strings.year}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_sctr',
        description: strings.cookiesSnapchatPixelId,
        expiration: `1 ${strings.year}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_ScCbts',
        description: strings.cookiesSnapchatTrackId,
        expiration: `0 ${strings.days}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
    ],
  },
  taboola: {
    name: 'Taboola',
    active: true,
    privacyUrl: 'https://www.taboola.com/policies/privacy-policy',
    list: [
      {
        id: 't_gid',
        description: strings.cookiesTaboolaUniqueId,
        expiration: `1 ${strings.year}`,
        domain: '.taboola.com',
      },
      {
        id: 't_pt_gid',
        description: strings.cookiesTaboolaUniqueId,
        expiration: `1 ${strings.year}`,
        domain: '.taboola.com',
      },
    ],
  },
  tiktok: {
    name: 'Tiktok',
    active: true,
    privacyUrl: 'https://www.tiktok.com/legal/page/row/privacy-policy/en',
    list: [
      {
        id: '_ttp',
        description: strings.cookiesTikTok,
        expiration: `13 ${strings.months}`,
        domain: '.tiktok.com',
      },
      {
        id: '_tt_enable_cookie',
        description: strings.cookiesTikTok,
        expiration: `13 ${strings.months}`,
        domain: '.tiktok.com',
      },
      {
        id: '_ttp',
        description: strings.cookiesTikTok,
        expiration: `13 ${strings.months}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_tt_enable_cookie',
        description: strings.cookiesTikTok,
        expiration: `13 ${strings.months}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
    ],
  },
  verizon: {
    name: 'Verizon',
    active: true,
    privacyUrl: 'https://www.verizon.com/about/privacy/full-privacy-policy',
    list: [
      {
        id: 'A1',
        description: strings.cookiesYahoo,
        expiration: `12 ${strings.months}`,
        domain: '.yahoo.com',
      },
      {
        id: 'A1S',
        description: strings.cookiesYahoo,
        expiration: 'session',
        domain: '.yahoo.com',
      },
      {
        id: 'A3',
        description: strings.cookiesYahoo,
        expiration: `12 ${strings.months}`,
        domain: '.yahoo.com',
      },
    ],
  },
  google: {
    name: 'Google Analytics',
    active: true,
    privacyUrl:
      'https://developers.google.com/terms/api-services-user-data-policy',
    list: [
      {
        id: 'AEC',
        description: strings.cookiesGoogleDetectSpam,
        expiration: `6 ${strings.months}`,
        domain: '.google.com',
      },
      {
        id: 'APISID',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: 'DV',
        description: strings.cookiesGoogleUseOurSite,
        expiration: `1 ${strings.day}`,
        domain: 'www.google.com',
      },
      {
        id: 'HSID',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: 'IDE',
        description: strings.cookiesGoogleDoubleClick,
        expiration: `390 ${strings.days}`,
        domain: '.doubleclick.net',
      },
      {
        id: 'NID',
        description: strings.cookiesGoogleUniqueIdTracking,
        expiration: `6 ${strings.months}`,
        domain: '.google.com',
      },
      {
        id: 'SAPISID',
        description: strings.cookiesGoogleUniqueIdTracking,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: 'SEARCH_SAMESITE',
        description: strings.cookiesGoogleCrossSite,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: 'SID',
        description: strings.cookiesGoogleUniqueIdTracking,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: 'SIDCC',
        description: strings.cookiesGoogleProtectData,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: 'SSID',
        description: strings.cookiesGoogleUniqueIdTracking,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-1PAPISID',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-1PSID',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-1PSIDCC',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-1PSIDTS',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-3PAPISID',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-3PSID',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-3PSIDCC',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '__Secure-3PSIDTS',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: '.google.com',
      },
      {
        id: '_ga',
        description: strings.cookiesGoogleDistinguishUsers,
        expiration: `2 ${strings.years}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_ga_1M1LTE26PK',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_ga_YH1D2Q77QB',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_ga_MWY9TRE1FP',
        description: strings.cookiesGoogleAds,
        expiration: `2 ${strings.years}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_gcl_au',
        description: strings.cookiesGoogleTrackConversions,
        expiration: `2 ${strings.years}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
    ],
  },
  vwo: {
    name: 'Visual Website Optimiser',
    active: true,
    privacyUrl: 'https://vwo.com/privacy-policy/',
    list: [
      {
        id: '_vis_opt_s',
        description: strings.cookiesVWOVisits,
        expiration: `100 ${strings.days}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_vis_opt_test_cookie',
        description: strings.cookiesVWOTest,
        expiration: 'session',
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_vwo',
        description: strings.cookiesVWOSafari,
        expiration: `2096 ${strings.years}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_vwo_ds',
        description: strings.cookiesVWODS,
        expiration: strings.cookiesVWOExpiration,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_vwo_uuid',
        description: strings.cookiesVWOUniqueId,
        expiration: `10 ${strings.years}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
      {
        id: '_vwo_uuid_v2',
        description: strings.cookiesVWOUniqueVisits,
        expiration: `1 ${strings.year}`,
        domain: config.DOMAIN,
        isFirstParty: true,
      },
    ],
  },
  appsFlyer: {
    name: 'AppsFlyer',
    active: true,
    privacyUrl: 'https://www.appsflyer.com/legal/privacy-policy/',
    list: [
      {
        id: 'AppsFlyer',
        description: strings.cookiesAppsFlyer,
        expiration: null,
        domain: '.appsflyer.com',
      },
    ],
  },
  romanceGuard: {
    name: 'Romance Guard',
    active: true,
    list: [
      {
        id: '__RG',
        description: strings.cookiesRomanceGuard,
        expiration: `4 ${strings.months}`,
        domain: config.DOMAIN,
      },
      {
        id: '__RGt',
        description: strings.cookiesRomanceGuard,
        expiration: `4 ${strings.months}`,
        domain: config.DOMAIN,
      },
    ],
  },
};

export const printOutCookiesList = () => {
  const arr = [];

  for (let providerId in providersCookiesList) {
    const provider = providersCookiesList[providerId];

    for (let i = 0; i < provider.list.length; i++) {
      const obj = {};
      obj.name = provider.name;
      const cookie = provider.list[i];
      obj.cookie = cookie.id;
      obj.expiration = cookie.expiration;
      obj.domain = cookie.domain;
      arr.push(obj);
    }
  }

  return arr;
};
